import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import CognitoFormAnswersScreen from './containers/CognitoFormAnswersScreenContainer';
import CognitoFormAnswerViewScreen from './containers/CognitoFormAnswerViewScreenContainer';

const register = () => {
  Logger.log('debug', `cognitoFormAnswers.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'cognitoFormAnswers', 'routes'])) {
    Events.dispatch('ADD_MAIN_ROUTES', {
      CognitoFormAnswerViewScreen: [
        'PrivateRoute',
        '/cognito-form-answers/view/:id([\\w\\-]+)',
        true,
        CognitoFormAnswerViewScreen,
        getI18n().t('cognito_form_answers_route_view'),
      ],
      CognitoFormAnswersScreen: [
        'PrivateRoute',
        '/cognito-form-answers/:page(\\d+)?',
        true,
        CognitoFormAnswersScreen,
        getI18n().t('cognito_form_answers_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `cognitoFormAnswers.register() loaded.`);
